module.exports = __webpack_public_path__ + "img/4.05.thmb.xs.f33b8b8f.jpg";